// extracted by mini-css-extract-plugin
export default {"container":"styles_container__3Bzxe","body":"styles_body__HH4pz","icone":"styles_icone__mNHfV"};